import { Observable } from 'rxjs';
import { ILanguageDescription } from '@valhalla/data/entities';

export abstract class LocalizationDataHttpService {
	abstract getLanguages(): Observable<Array<ILanguageDescription>>;

	abstract getCurrentLanguage(): Observable<ILanguageDescription>;

	abstract setLanguage(criteria: ILocalizationSetLanguageCriteria, allowNotification?: boolean): Observable<any>;
}

export interface ILocalizationSetLanguageCriteria {
	alias: string;
}
